var map = {
	"./about_de.md": "Gwvo",
	"./contact_de.md": "sB77",
	"./datenschutz_de.md": "Nt3/",
	"./impressum_de.md": "8/z7",
	"./jobs_de.md": "3SrD",
	"./menu_de.md": "oHSG",
	"./news_de.md": "9zC8",
	"./opening_de.md": "F2/0",
	"./press_de.md": "0XrP",
	"./veg_de.md": "yuQb",
	"./wine_de.md": "6rrY"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Mk8c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/copy ^\.\/.*_de\.md$
// module id = Mk8c
// module chunks = 0